<ng-container *ngIf="(selectedOrganization$ | async) as selectedOrganization">
  <div class="aw-dialog">
    <div class="aw-dialog-header">Create new Group</div>
    <div class="aw-dialog-sub-header">Create a group to manage your devices.</div>

    <div class="aw-input-header">Name</div>
    <input (ngModelChange)="onChangeName($event)" (keyup.enter)="onCreate()" type="text" autocomplete="off" placeholder="Name your Group" required ngModel>
    <!-- Error message -->
    <div class="error-msg" [class.show-error-msg]="isError" id="warning-msg">
      {{errMsg}}
    </div>
    <!-- /.Error message -->
    <div class="btn-set">
      <button class="aw-btn aw-btn-gray" (click)="onCancel()">Cancel</button>
      <button class="aw-btn aw-btn-blue" (click)="onCreate(selectedOrganization.token)" [disabled]="isLoading || isError || groupName.length === 0">Create</button>
    </div>
  </div>
</ng-container>
